/**
 * 公共接口
 */

import API from "../apis";
import requestFormData from "../requestFormData";
import request from "../request";

// 上传文件
export async function uploadFileApi(data) {
  return requestFormData({
    url: API.uploadFile,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 获取字典数据
export async function getEnumByCodeApi(data) {
  return request({
    url: API.getEnumByCode,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 获取基础配置
export async function getSettingApi(data) {
  return request({
    url: API.getSetting,
    method: "POST",
    data,
  }).catch((e) => e);
}
